var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mast-head logo-wpr"},[_c('div',{staticClass:"logo-masthead",on:{"click":_vm.handleLogoClick}},[_c('img',_vm._b({},'img',_vm.config.logo,false))]),_c('flyer-validity-dates',{attrs:{"feature-config":_vm.config.validityDates}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }